import { __assign, __extends } from "tslib";
// TS adapted from https://github.com/bhubr/react-simple-oauth2-login/blob/master/src/OAuth2Login.jsx
import React, { Component } from 'react';
import PopupWindow from '../../util/PopupWindow';
import { toQuery } from '../../util/url';
var defaultProps = {
    autoLogin: false,
    buttonText: 'Login',
    scope: '',
    state: '',
    className: '',
    children: undefined,
    onRequest: function () { }
};
var responseTypeLocationKeys = {
    code: 'search',
    token: 'hash'
};
var responseTypeDataKeys = {
    code: 'code',
    token: 'access_token'
};
var OAuth2Login = /** @class */ (function (_super) {
    __extends(OAuth2Login, _super);
    function OAuth2Login(props) {
        var _this = _super.call(this, props) || this;
        _this.onBtnClick = _this.onBtnClick.bind(_this);
        _this.onRequest = _this.onRequest.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onFailure = _this.onFailure.bind(_this);
        return _this;
    }
    OAuth2Login.prototype.onBtnClick = function () {
        var _a;
        var _b = this.props, buttonText = _b.buttonText, authorizationUrl = _b.authorizationUrl, clientId = _b.clientId, scope = _b.scope, redirectUri = _b.redirectUri, state = _b.state, responseType = _b.responseType;
        var payload = {
            client_id: clientId,
            scope: scope,
            redirect_uri: redirectUri,
            response_type: responseType,
            nonce: 'fixme'
        };
        if (state) {
            payload.state = state;
        }
        var search = toQuery(payload);
        var width = 680;
        var height = 440;
        var left = window.screenX + (window.outerWidth - width) / 2;
        var top = window.screenY + (window.outerHeight - height) / 2.5;
        var locationKey = responseTypeLocationKeys[responseType];
        console.log("opening popup window: " + authorizationUrl + "?" + search);
        var popup = PopupWindow.open(buttonText, authorizationUrl + "?" + search, {
            height: height,
            width: width,
            top: top,
            left: left
        }, {
            locationKey: locationKey
        });
        this.popup = popup;
        this.onRequest();
        (_a = popup.then(this.onSuccess)) === null || _a === void 0 ? void 0 : _a.catch(this.onFailure);
    };
    OAuth2Login.prototype.componentDidMount = function () {
        if (this.props.autoLogin) {
            this.onBtnClick();
        }
    };
    OAuth2Login.prototype.onRequest = function () {
        var onRequest = this.props.onRequest;
        onRequest();
    };
    OAuth2Login.prototype.onSuccess = function (data) {
        var _a = this.props, responseType = _a.responseType, onSuccess = _a.onSuccess;
        var responseKey = responseTypeDataKeys[responseType];
        if (!data[responseKey]) {
            console.error('received data', data);
            return this.onFailure(new Error("'" + responseKey + "' not found in received data"));
        }
        return onSuccess(data);
    };
    OAuth2Login.prototype.onFailure = function (error) {
        var onFailure = this.props.onFailure;
        onFailure(error);
    };
    OAuth2Login.prototype.render = function () {
        var _a = this.props, className = _a.className, buttonText = _a.buttonText, children = _a.children;
        var attrs = { onClick: this.onBtnClick, className: '' };
        if (className) {
            attrs.className = className;
        }
        // eslint-disable-next-line react/jsx-props-no-spreading
        return (React.createElement("button", __assign({ type: "button" }, attrs), children || buttonText));
    };
    OAuth2Login.defaultProps = defaultProps;
    return OAuth2Login;
}(Component));
export { OAuth2Login };
//# sourceMappingURL=OAuthLogin.js.map